export default "__VITE_ASSET__0XJhCjTU__"